window.bb2PdfErstellen = function () {
  if (!window.bb2Positionen || window.bb2Positionen.length === 0) {
    alert('Bitte zuerst mindestens eine Position hinzufügen.');
    return;
  }

  const kunde = document.getElementById('bb2Kunde')?.value || '-';
  const ansprechpartner = document.getElementById('bb2Ansprechpartner')?.value || '-';
  const email = document.getElementById('bb2Email')?.value || '-';

  const programm = window.bb2AktuellesProgramm || {};
  const istMonatsabo = typeof window.bb2ProgrammIstMonatsabo === 'function' && window.bb2ProgrammIstMonatsabo();
  const istJahresabo = typeof window.bb2ProgrammIstJahresabo === 'function' && window.bb2ProgrammIstJahresabo();
  const istAbo = istMonatsabo || istJahresabo;

  const heute = new Date().toLocaleDateString('de-DE');
  const gueltigBis = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toLocaleDateString('de-DE');

  const standardwert = window.bb2Positionen.reduce((sum, p) => sum + (p.nettoVorRabatt || p.netto || 0), 0);
  const preisvorteilGesamt = window.bb2Positionen.reduce((sum, p) => sum + (p.rabattbetrag || 0), 0);
  const netto = window.bb2Positionen.reduce((sum, p) => sum + (p.netto || 0), 0);
  const mwst = netto * 0.07;
  const brutto = netto + mwst;
  const gewichtGesamt = window.bb2Positionen.reduce((sum, p) => sum + (p.gewichtKg || 0), 0);

  const jahresMenge = window.bb2Positionen.reduce((sum, p) => sum + (p.jahresMenge || 0), 0);
  const jahresNetto = window.bb2Positionen.reduce((sum, p) => sum + (p.jahresNetto || 0), 0);
  const jahresBrutto = window.bb2Positionen.reduce((sum, p) => sum + (p.jahresBrutto || 0), 0);

  function zahl(value) {
    return Number(value || 0);
  }

  function sichtbarerEinzelpreis(p) {
    return zahl(p.finalerPreis || p.staffelPreis || p.einzelpreis);
  }

  function sichtbarerStufenpreis(p) {
    return zahl(p.staffelPreis || p.finalerPreis || p.einzelpreis);
  }

  function preisvorteilText(p) {
    const standard = zahl(p.einzelpreis);
    const stufe = sichtbarerStufenpreis(p);
    const final = sichtbarerEinzelpreis(p);

    let teile = [];

    if (standard > 0 && stufe > 0 && Math.abs(standard - stufe) > 0.001) {
      teile.push('Mengenkondition: ' + window.bb2Euro(stufe));
    } else {
      teile.push('Standardpreis');
    }

    if (istAbo && zahl(p.programmRabatt) > 0) {
      teile.push('Partnerbonus: ' + zahl(p.programmRabatt).toLocaleString('de-DE') + ' %');
      teile.push('Final: ' + window.bb2Euro(final));
    }

    return teile.join('<br>');
  }

  function stufenText(p) {
    const staffel = [];

    if (p.rabattMenge1 > 0 && p.rabatt1 > 0) {
      staffel.push('ab ' + p.rabattMenge1 + ' VE: ' + window.bb2Euro(p.rabatt1));
    }

    if (p.rabattMenge2 > 0 && p.rabatt2 > 0) {
      staffel.push('ab ' + p.rabattMenge2 + ' VE: ' + window.bb2Euro(p.rabatt2));
    }

    if (p.rabattMenge3 > 0 && p.rabatt3 > 0) {
      staffel.push('ab ' + p.rabattMenge3 + ' VE: ' + window.bb2Euro(p.rabatt3));
    }

    if (istAbo && p.programmRabatt > 0) {
      staffel.push('Partnerbonus zusätzlich: ' + p.programmRabatt + ' %');
    }

    return staffel.length ? staffel.join('<br>') : 'Keine Preisstufen hinterlegt';
  }

  let positionenHTML = '';
  let preisstaffelHTML = '';

  window.bb2Positionen.forEach((p, index) => {
    const einheitspreis = sichtbarerEinzelpreis(p);

    positionenHTML += `
      <tr>
        <td>${index + 1}</td>
        <td>
          <strong>${p.artikel}</strong><br>
          Sorte: ${p.sorte}<br>
          Bombiza gesamt: ${p.bombizaGesamt}<br>
          Gewicht: ca. ${(p.gewichtKg || 0).toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })} kg<br>
          Netto pro Bombiza Standardpreis: ${window.bb2Euro(p.preisProBombizaVorRabatt || 0)}<br>
          Netto pro Bombiza final: ${window.bb2Euro(p.preisProBombizaNachRabatt || 0)}
        </td>
        <td>${p.menge}</td>
        <td>VE</td>
        <td>${window.bb2Euro(einheitspreis)}</td>
        <td>${preisvorteilText(p)}</td>
        <td>${window.bb2Euro(p.netto || 0)}</td>
      </tr>
    `;

    preisstaffelHTML +=
      'Position ' + (index + 1) + ' (' + p.artikel + ' – ' + p.sorte + '):<br>' +
      stufenText(p) + '<br><br>';
  });

  const vertragsBlock = `
    <div class="contract-box">
      <strong>Vertragsmodell:</strong> ${programm.name || '-'}<br>
      ${programm.programmart ? '<strong>Programmart:</strong> ' + programm.programmart + '<br>' : ''}
      ${programm.laufzeitMonate ? '<strong>Laufzeit:</strong> ' + programm.laufzeitMonate + ' Monate<br>' : ''}
      ${programm.mindestabnahme ? '<strong>Mindestabnahme:</strong> ' + programm.mindestabnahme + ' ' + (programm.mindestabnahmeTyp || '') + '<br>' : ''}
      ${programm.lieferintervall ? '<strong>Lieferintervall:</strong> ' + programm.lieferintervall + '<br>' : ''}
      ${istAbo && Number(programm.rabattZusatz || 0) > 0 ? '<strong>Partnerbonus:</strong> ' + programm.rabattZusatz + ' %<br>' : ''}
    </div>
  `;

  const jahresBlock = istMonatsabo ? `
    <div class="contract-box">
      <strong>Monatsabo-Zusammenfassung:</strong><br>
      Monatliche Menge: ${window.bb2Positionen.reduce((sum, p) => sum + (p.menge || 0), 0)} Boxen<br>
      Vertragsmenge: ${jahresMenge} Boxen<br>
      Monatlicher Nettowert: ${window.bb2Euro(netto)}<br>
      Vertragswert netto: ${window.bb2Euro(jahresNetto)}<br>
      Vertragswert brutto: ${window.bb2Euro(jahresBrutto)}
    </div>
  ` : istJahresabo ? `
    <div class="contract-box">
      <strong>Jahresabo-Zusammenfassung:</strong><br>
      Jahresmenge: ${window.bb2Positionen.reduce((sum, p) => sum + (p.menge || 0), 0)} Boxen<br>
      Jahreswert netto: ${window.bb2Euro(netto)}<br>
      Jahreswert brutto: ${window.bb2Euro(brutto)}
    </div>
  ` : '';

  const preisvorteilZeile = preisvorteilGesamt > 0.001 ? `
    <div class="total-row advantage-row">
      <span>Preisvorteil durch Mengenkondition${istAbo ? ' / Partnerbonus' : ''}</span>
      <span>- ${window.bb2Euro(preisvorteilGesamt)}</span>
    </div>
  ` : '';

  const angebotHTML = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8">
  <title>Vorläufiges Angebot BoomBiza</title>

  <style>
    @page {
      size: A4;
      margin: 18mm 15mm 18mm 15mm;
    }

    body {
      font-family: Arial, sans-serif;
      color: #222;
      margin: 0;
      padding: 0;
      background: #ffffff;
      font-size: 13px;
    }

    .top {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 45px;
    }

    .logo {
      width: 145px;
    }

    .offer-meta {
      text-align: right;
      line-height: 1.7;
    }

    .offer-title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .address-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 45px;
    }

    .customer {
      width: 48%;
      line-height: 1.6;
    }

    .company {
      width: 38%;
      text-align: right;
      line-height: 1.7;
    }

    .small {
      font-size: 11px;
      color: #777;
    }

    .contract-box {
      border: 1px solid #ddd;
      background: #f7f7f7;
      padding: 12px 14px;
      margin-bottom: 20px;
      line-height: 1.6;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .section-title {
      margin-bottom: 14px;
      font-size: 15px;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      page-break-inside: auto;
    }

    thead {
      border-top: 2px solid #999;
      border-bottom: 2px solid #999;
      display: table-header-group;
    }

    th {
      text-align: left;
      padding: 8px 6px;
      font-size: 12px;
    }

    td {
      padding: 10px 6px;
      vertical-align: top;
      font-size: 12px;
    }

    tbody tr {
      border-bottom: 1px solid #ddd;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .total-wrapper {
      width: 420px;
      margin-left: auto;
      margin-top: 24px;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .total-row {
      display: flex;
      justify-content: space-between;
      gap: 18px;
      padding: 9px 12px;
      border-bottom: 1px solid #ddd;
    }

    .advantage-row {
      color: #7a5a43;
    }

    .netto-after-discount {
      font-weight: 700;
    }

    .total-final {
      background: #efefef;
      font-weight: 700;
    }

    .notes {
      margin-top: 38px;
      line-height: 1.75;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .legal-note {
      margin-top: 26px;
      font-size: 12px;
      color: #666;
      line-height: 1.5;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .legal-footer-wrap {
      margin-top: 55px;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .legal-footer {
      display: flex;
      justify-content: space-between;
      gap: 25px;
      border-top: 1px solid #bbb;
      padding-top: 12px;
      font-size: 10px;
      color: #555;
      line-height: 1.35;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .legal-footer div {
      width: 33.33%;
    }

    @media print {
      .legal-footer-wrap,
      .legal-footer {
        page-break-inside: avoid;
        break-inside: avoid;
      }
    }
  </style>
</head>

<body>
  <div class="top">
    <div>
      <img class="logo" src="https://cdn.shopify.com/s/files/1/0955/8579/6428/files/LOGO.png?v=1764327273">
    </div>

    <div class="offer-meta">
      <div class="offer-title">Angebot</div>
      <strong>Datum:</strong> ${heute}<br>
      <strong>Gültig bis:</strong> ${gueltigBis}<br>
      <strong>Status:</strong> Vorläufiges Angebot
    </div>
  </div>

  <div class="address-row">
    <div class="customer">
      <div class="small">
        BoomBiza UG (haftungsbeschränkt) · Mühlenweg 4 · 88682 Salem
      </div>
      <br>
      <strong>${kunde}</strong><br>
      ${ansprechpartner}<br>
      ${email}
    </div>

    <div class="company">
      <strong>BoomBiza UG (haftungsbeschränkt)</strong><br>
      Mühlenweg 4<br>
      88682 Salem<br><br>
      info@boombiza.de<br>
      www.boombiza.de
    </div>
  </div>

  ${vertragsBlock}
  ${jahresBlock}

  <div class="section-title">
    Gerne bieten wir Ihnen an:
  </div>

  <table>
    <thead>
      <tr>
        <th>Pos.</th>
        <th>Bezeichnung</th>
        <th>Menge</th>
        <th>Einheit</th>
        <th>Einzel €</th>
        <th>Kondition</th>
        <th>Gesamt netto €</th>
      </tr>
    </thead>

    <tbody>
      ${positionenHTML}
    </tbody>
  </table>

  <div class="total-wrapper">
    <div class="total-row">
      <span>${istMonatsabo ? 'Monatssumme Standardpreis' : 'Zwischensumme Standardpreis'}</span>
      <span>${window.bb2Euro(standardwert)}</span>
    </div>

    ${preisvorteilZeile}

    <div class="total-row netto-after-discount">
      <span>${istMonatsabo ? 'Monatliche Nettosumme' : 'Nettosumme'}</span>
      <span>${window.bb2Euro(netto)}</span>
    </div>

    <div class="total-row">
      <span>Umsatzsteuer 7 %</span>
      <span>${window.bb2Euro(mwst)}</span>
    </div>

    <div class="total-row total-final">
      <span>${istMonatsabo ? 'Monatliche Bruttosumme' : 'Gesamtbetrag brutto'}</span>
      <span>${window.bb2Euro(brutto)}</span>
    </div>
  </div>

  <div class="notes">
    Zahlbar innerhalb von 14 Tagen ohne Abzug.<br>
    Lieferbedingungen: Ab Werk / Ex Works (EXW)<br><br>

    Produktions-Vorlaufzeit: ca. 2–3 Wochen je nach Menge.<br>
    Versandlaufzeit: gewöhnlich 3–4 Werktage.<br>
    Versandkosten zzgl.<br>
    Geschätztes Gesamtgewicht: ca. ${gewichtGesamt.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} kg.<br>
    Mindesthaltbarkeit: ca. 3 Monate.<br>
    Lagerung: Kühl und trocken lagern, vor Wärme schützen.<br><br>

    ${preisstaffelHTML ? '<strong>Preisstufen / Mengenkonditionen:</strong><br>' + preisstaffelHTML : ''}

    Wir freuen uns auf Ihre Anfrage und sichern eine einwandfreie Ausführung zu.
  </div>

  <div class="legal-note">
    Dieses Angebot ist freibleibend und unverbindlich. Änderungen bezüglich Preis, Verfügbarkeit, Lieferzeit und Versandkosten vorbehalten.
  </div>

  <div class="legal-footer-wrap">
    <div class="legal-footer">
      <div>
        BoomBiza UG (haftungsbeschränkt)<br>
        Mühlenweg 4<br>
        88682 Salem<br>
        info@boombiza.de<br>
        www.boombiza.de
      </div>

      <div>
        USt-IdNr.: DE454940899<br>
        Steuernummer: 87007/22079<br>
        Registergericht: Amtsgericht Freiburg<br>
        HRB 733277<br>
        Geschäftsführer: Luan Franc
      </div>

      <div>
        Finom Payments<br>
        IBAN: DE07 1001 8000 0197 3941 47<br>
        BIC: FNOMDEB2
      </div>
    </div>
  </div>
</body>
</html>
`;

  const printWindow = window.open('', '_blank');

  if (!printWindow) {
    alert('Pop-up wurde blockiert. Bitte Pop-ups für diese Seite erlauben.');
    return;
  }

  printWindow.document.open();
  printWindow.document.write(angebotHTML);
  printWindow.document.close();

  setTimeout(function () {
    printWindow.focus();
    printWindow.print();
  }, 500);
};